// GENERATED by scripts/build-icons.mjs from icons/chevron-right.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const ChevronRight = createIcon('chevron-right', [
  ['path', { d: "m9 18 6-6-6-6" }],
])
